// extracted by mini-css-extract-plugin
module.exports = {"LoaderLayer":"Loader_LoaderLayer__3HyK9","big-to-small":"Loader_big-to-small__31K1w","small-to-big":"Loader_small-to-big__ALkoS","loading-noku3":"Loader_loading-noku3__1Y5uF"};